import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import axios from 'axios';
import { useTranslation } from "react-i18next";
import { useCookies } from 'react-cookie';
import Carousel from 'react-bootstrap/Carousel';

const IsuTerkiniDetail = () => {
    const [cookies] = useCookies(['i18next']);
    const { t } = useTranslation();
    dayjs.locale('id');

    const formatDate = (date, locale = 'en') => {
        dayjs.locale(locale);
        return dayjs(date).format('DD MMMM YYYY');
    };

    const { id, slug } = useParams();
    const [rows, setItem] = useState([]);
    const [itemx, setItemx] = useState([]);
    const effectrun = useRef(false);

    const resolveImageUrl = (path, type = 'news') => {
        if (!path || path === "") return '/assets/image/foto-beritas.png';
        if (path.startsWith('http://') || path.startsWith('https://')) {
            return path;
        }
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        if (cleanPath.startsWith('/assets/') || cleanPath.startsWith('/static/')) {
            const publicUrl = process.env.PUBLIC_URL || '';
            const cleanPublicUrl = publicUrl.endsWith('/') ? publicUrl.slice(0, -1) : publicUrl;
            return `${cleanPublicUrl}${cleanPath}`;
        }
        if (path.includes('uploads/') || path.includes('storage/')) {
            const cmsUrl = process.env.REACT_APP_API_URL || 'https://cms.kneks.go.id';
            const cleanCmsUrl = cmsUrl.endsWith('/') ? cmsUrl.slice(0, -1) : cmsUrl;
            return `${cleanCmsUrl}${cleanPath}`;
        }
        if (type === 'gallery') {
            const galleryBase = process.env.REACT_APP_API_PHOTO_BERITA || 'https://cms.kneks.go.id/uploads/photo/';
            const cleanGalleryBase = galleryBase.endsWith('/') ? galleryBase : `${galleryBase}/`;
            return `${cleanGalleryBase}${path.startsWith('/') ? path.slice(1) : path}`;
        } else {
            const newsBase = process.env.REACT_APP_API_NEWS || 'https://cms.kneks.go.id/storage/news/';
            const cleanNewsBase = newsBase.endsWith('/') ? newsBase : `${newsBase}/`;
            return `${cleanNewsBase}${path.startsWith('/') ? path.slice(1) : path}`;
        }
    };

    const convertToSlug = (title) => {
        if (!title) return '';
        return title
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
    };

    useEffect(() => {
        if (effectrun.current === false) {
            const fetchPosts = async () => {
                try {
                    const url = process.env.REACT_APP_API_URL;
                    const endpoint = '/hotissue';
                    const responsei = await axios.get(`${url}/hotissuedetail/${atob(id)}`);
                    const responlain = await axios.get(`${url}${endpoint}`);

                    if (responlain) {
                        setItemx(responlain.data);
                        setItem(responsei.data);
                    }
                } catch (err) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: err.message || "An error occurred while fetching data.",
                    });
                }
            };

            fetchPosts();

            return () => {
                effectrun.current = true;
            }
        }
    }, [id, slug]);

    useEffect(() => {
        if (!rows || rows.length === 0) return;

        document.title = rows[0]?.title || "Detail Berita";

        // --- Meta Description ---
        const metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        metaDescription.content = rows[0]?.content || "";
        document.head.appendChild(metaDescription);

        // --- OG Title ---
        const metaOgTitle = document.createElement("meta");
        metaOgTitle.setAttribute("property", "og:title");
        metaOgTitle.content = rows[0]?.title || "";
        document.head.appendChild(metaOgTitle);

        // --- OG Description ---
        const metaOgDescription = document.createElement("meta");
        metaOgDescription.setAttribute("property", "og:description");
        metaOgDescription.content = rows[0]?.content || "";
        document.head.appendChild(metaOgDescription);

        // --- OG Image ---
        const metaOgImage = document.createElement("meta");
        metaOgImage.setAttribute("property", "og:image");
        metaOgImage.content = !rows[0]?.image ? '/assets/image/foto-beritas.png' : rows[0]?.image;
        document.head.appendChild(metaOgImage);

        return () => {
            document.head.removeChild(metaDescription);
            document.head.removeChild(metaOgTitle);
            document.head.removeChild(metaOgDescription);
            document.head.removeChild(metaOgImage);
        };
    }, [rows]);

    const images = [];
    if (rows && rows.length > 0 && rows[0]) {
        const data = rows[0];

        if (data?.image && data?.image !== "") {
            const imgList = data.image.split(',').map(s => s.trim()).filter(Boolean);
            imgList.forEach(url => images.push(resolveImageUrl(url, 'news')));
        }

        if (Array.isArray(data?.foto_gallery) && data.foto_gallery.length > 0) {
            data.foto_gallery.forEach(result => {
                if (result?.foto) {
                    images.push(resolveImageUrl(result.foto, 'gallery'));
                }
            });
        }

        if (images.length === 0) {
            images.push('/assets/image/foto-beritas.png');
        }
    }

    return (
        <div className="page-wrapper">
            <section className="page-banner">
                <div className="container">
                    <div className="page-banner-title">
                        <h3>{t('isuTerkini')}</h3>
                    </div>
                </div>
            </section>

            <section className="event-details-section-ber">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="event-details-content-box">
                                <h4>{cookies.i18next === 'en' ? rows[0]?.title_en : rows[0]?.title}</h4>
                                <p>{cookies.i18next === 'id' ? formatDate(rows[0]?.hot_issue_datetime, 'id') : formatDate(rows[0]?.hot_issue_datetime, 'en')}</p>
                            </div>
                        </div>

                        <div className="col-lg-12 pb-4">
                            {images.length > 0 ? (
                                <Carousel
                                    interval={3000}
                                    controls={images.length > 1}
                                    indicators={images.length > 1}
                                    className="news-carousel-container"
                                >
                                    {images.map((imgSrc, idx) => (
                                        <Carousel.Item key={idx}>
                                            <div className="news-carousel-img-wrapper">
                                                <img
                                                    src={imgSrc}
                                                    className="news-carousel-img img-fluid"
                                                    alt={`${rows[0]?.title || 'Berita'} - ${idx + 1}`}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = `/assets/image/foto-beritas.png`;
                                                    }}
                                                />
                                            </div>
                                        </Carousel.Item>
                                    ))}
                                </Carousel>
                            ) : (
                                <div className="event-details-inner-box">
                                    <img src='/assets/image/foto-beritas.png' width="100%" className="img-fluid" alt="Placeholder" />
                                </div>
                            )}
                        </div>

                        <div className="row">
                            {rows[0]?.foto_gallery && rows[0]?.foto_gallery.length > 0 ? (
                                rows[0]?.foto_gallery.map((result, index) => (
                                    <div className="col-lg-3 pb-3" key={index}>
                                        <a href={resolveImageUrl(result.foto, 'gallery')} className="beritaDetail" data-gall="gallery01">
                                            <img
                                                src={resolveImageUrl(result.foto, 'gallery')}
                                                width="100%"
                                                style={{ height: "195px", objectFit: "cover" }}
                                                className="img-fluid"
                                                alt={rows[0]?.title || "Gallery Item"}
                                            />
                                        </a>
                                    </div>
                                ))
                            ) : null}
                        </div>

                        <div className="col-lg-12">
                            <div className="event-details-connt-box">
                                <div dangerouslySetInnerHTML={{ __html: cookies.i18next === 'en' ? rows[0]?.content_en : rows[0]?.content }} />
                            </div>
                        </div>

                        <hr />

                        <div className="news-details-list-title pb-3">
                            <h4>Tags :</h4>
                        </div>

                        {rows[0]?.tag && (
                            <div className="news-details-list-button">
                                {(JSON.parse(rows[0]?.tag || '[]')).map((t, i) => (
                                    <a key={i} href="#t" className="btn btn-primary me-2 mb-2">
                                        {t.value}
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <section className="berita-section-det">
                <div className="container">
                    <div className="row row-gutter-y-40 mb-5">
                        <div className="col-lg-12 col-xl-12">
                            <div className="about-one-inner">
                                <div className="section-tagline">
                                    Berita Lainnya
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row row-gutter-30">
                        {itemx.slice(0, 3).map((item) => {
                            return (
                                <div className="col-lg-4 col-xl-4" key={item.id}>
                                    <div className="berita-card">
                                        <div className="berita-card-imgbox ">
                                            <a href={`/isu-terkini/${btoa(item.id)}/${convertToSlug(item.title)}`}>
                                                <img
                                                    src={item?.image === "" ? '/assets/image/foto-beritas.png' : item?.image}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = `/assets/image/foto-beritas.png`;
                                                    }}
                                                    className="img-fluid w-100"
                                                    style={{ height: "200px", objectFit: "cover" }}
                                                    alt={item.title}
                                                />
                                            </a>
                                        </div>
                                        <div className="berita-content ">
                                            <div className="event-card-info-x " style={{ color: `#F2994A` }}>
                                                {item?.tags?.split(",").map((tag, index) => (
                                                    <span key={index}>{tag ? '#' + tag.trim() : ''} </span>
                                                ))}
                                            </div>
                                            <div className="event-card-title pb-4 mt-2">
                                                <h4>
                                                    <a href={`/isu-terkini/${btoa(item.id)}/${convertToSlug(item.title)}`}>{item.title}</a>
                                                </h4>
                                            </div>
                                            <div className="event-card-info">
                                                <span>{dayjs(item?.hot_issue_datetime).format("DD MMMM YYYY")}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default IsuTerkiniDetail;